document.addEventListener('DOMContentLoaded', () => {
  let observer = null;

  const applyRecurringTotalColspan = () => {
    document.querySelectorAll('.order-total.recurring-total td[data-title]').forEach((td) => {
      td.setAttribute('colspan', '2');
    });
  };

  const isVisible = (el) => {
    if (!el) return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  };

  const isPaymentRequest = () => {
    const applepay = document.querySelector('#payment_method_stripe_applepay');
    const gpay = document.querySelector('#payment_method_stripe_payment_request');
    return (applepay && applepay.checked) || (gpay && gpay.checked);
  };

  const isCheckoutValid = () => {
    const form = document.querySelector('form.checkout');
    if (!form) return false;

    const requiredFields = form.querySelectorAll(
      'input[required]:not([type="hidden"]), select[required], textarea[required], ' +
      '.validate-required input:not([type="hidden"]), .validate-required select, .validate-required textarea'
    );

    return [...requiredFields].every((field) => {
      // Ignorer les champs cachés (display: none ou parent caché)
      if (!isVisible(field) && field.type !== 'checkbox') return true;
      
      if (field.type === 'checkbox') {
        return !isVisible(field) || field.checked;
      }
      return field.value.trim() !== '';
    });
  };

  const update = () => {
    applyRecurringTotalColspan();

    const payment = document.querySelector('#payment');
    if (!payment) return;

    const paymentRequest = payment.querySelector('#wc-stripe-payment-request-container');
    const mrwp = payment.querySelector('.mrwpbutton');
    if (!paymentRequest || !mrwp) return;

    // Gérer le message
    let messageEl = payment.querySelector('.stripe-address-warning');

    // Afficher seulement si mrwp n'est pas visible ET applepay/gpay est sélectionné
    const shouldShow = !isVisible(mrwp) && isPaymentRequest();
    paymentRequest.style.display = shouldShow ? '' : 'none';

    // Désactiver si checkout invalide
    if (shouldShow) {
      if (!isCheckoutValid()) {
        paymentRequest.style.opacity = '0.5';
        paymentRequest.style.pointerEvents = 'none';
        
        if (!messageEl) {
          messageEl = document.createElement('p');
          messageEl.className = 'stripe-address-warning';
          messageEl.style.cssText = 'color: #666; font-size: 14px; margin: 10px 0;';
          messageEl.textContent = 'Veuillez compléter les champs obligatoires pour utiliser Apple Pay / Google Pay.';
          paymentRequest.parentNode.insertBefore(messageEl, paymentRequest);
        }
        messageEl.style.display = '';
      } else {
        paymentRequest.style.opacity = '';
        paymentRequest.style.pointerEvents = '';
        if (messageEl) messageEl.style.display = 'none';
      }
    } else if (messageEl) {
      messageEl.style.display = 'none';
    }
  };

  const observe = () => {
    if (observer) observer.disconnect();

    const payment = document.querySelector('#payment');
    if (!payment) return;

    observer = new MutationObserver(() => {
      update();
    });

    observer.observe(payment, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style', 'class']
    });

    // Réinitialiser Stripe et update après un délai
    setTimeout(() => {
      update();
    }, 100);
  };

  // Attendre que WooCommerce ait fini de charger le checkout
  if (window.jQuery) {
    jQuery(document.body).on('updated_checkout', () => {
      applyRecurringTotalColspan();
      observe();
    });
  }

  // Changement moyen de paiement / livraison / champs
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="payment_method"], input[name^="shipping_method"], input, select, textarea')) {
      setTimeout(update, 100);
    }
  });

  document.addEventListener('input', (e) => {
    if (e.target.matches('input, textarea')) {
      update();
    }
  });

  applyRecurringTotalColspan();
  observe();
});